import { render, staticRenderFns } from "./CardDeviceStatus.vue?vue&type=template&id=8132ad5c&scoped=true&"
import script from "./CardDeviceStatus.vue?vue&type=script&lang=js&"
export * from "./CardDeviceStatus.vue?vue&type=script&lang=js&"
import style0 from "./CardDeviceStatus.vue?vue&type=style&index=0&id=8132ad5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8132ad5c",
  null
  
)

export default component.exports